import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material";
import "./assets/fonts/Aldrich-Regular.ttf";
import "./assets/fonts/GESndBook.ttf";

String.prototype.toArabic = function () {
  var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  var a = this;

  // a.match(/[0-9]*/g)
  //   .filter((v) => !!v)
  //   .map((v) => (a = a.replace(v, v.split('').reverse().join(''))));
  a = a.replace(/[0-9]/g, function (w) {
    return id[+w];
  });
  a.match();
  return a;
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
